import { useEffect } from 'react';
import { setBufferZone } from 'pages/GlobalMap/Layers';
import { setLayerVisibility } from 'pages/GlobalMap/MapLayers';

export const useBufferZone = (map) => {
  useEffect(() => {
    const loadBufferZone = async () => {
      if (!map || map?.getSource('buffer-zone')) return;

      try {
        await setBufferZone(map);
        setLayerVisibility(map, 'buffer-zone-layer', true);
      } catch (error) {
        console.error('Error loading buffer zone:', error);
      }
    };

    loadBufferZone();
  }, [map]);
};